import { EWatchlistFilter } from '@webtrader/core/api/market/watchlist';
import { EThemeScheme } from '@webtrader/core/themes';

import { EMixpanelWatchlistFilter, EMixpanlThemeScheme } from '../../constants';

class EventPropertiesHelper {
  public mapWatchListEventProperties = (watchList: EWatchlistFilter) => {
    const actionEventMap: { [key in EWatchlistFilter]?: EMixpanelWatchlistFilter } = {
      [EWatchlistFilter.POPULAR]: EMixpanelWatchlistFilter.POPULAR,
      [EWatchlistFilter.TOP_LOSER]: EMixpanelWatchlistFilter.TOP_LOSER,
      [EWatchlistFilter.TOP_GAINER]: EMixpanelWatchlistFilter.TOP_GAINER,
      [EWatchlistFilter.FAVOURITES]: EMixpanelWatchlistFilter.FAVOURITES,
      [EWatchlistFilter.TOP_PICK]: EMixpanelWatchlistFilter.TOP_PICK,
      [EWatchlistFilter.ALL]: EMixpanelWatchlistFilter.ALL
    };
    return actionEventMap[watchList];
  };

  public mapThemeSchemeEventProperties = (themeScheme: EThemeScheme) => {
    const actionEventMap: { [key in EThemeScheme]?: EMixpanlThemeScheme } = {
      [EThemeScheme.DARK]: EMixpanlThemeScheme.DARK,
      [EThemeScheme.LIGHT]: EMixpanlThemeScheme.LIGHT,
      [EThemeScheme.SYSTEM]: EMixpanlThemeScheme.SYSTEM
    };
    return actionEventMap[themeScheme];
  };
}

const eventPropertiesHelper = new EventPropertiesHelper();
export default eventPropertiesHelper;
